import React from "react";
import { ResponsivePie } from "@nivo/pie";
import { generatePieData } from "../../../utils/chartsData/pieData";
import { numberWithCommas } from "../../../utils/helpers/numberConverter";
import { useTranslation } from "react-i18next";
import "./FinancePie.css";

const FinancePie = (props) => {
  const { t, i18n } = useTranslation("common");
  const CenteredMetric = ({ dataWithArc, centerX, centerY }) => {
    let total = 0;
    dataWithArc.forEach((datum) => {
      total += datum.value;
    });
    const totalWithCommas = numberWithCommas(Math.floor(total));

    return (
      <>
        <p className="visually-hidden"> ₪{totalWithCommas}</p>
        <text
          x={centerX}
          y={centerY}
          textAnchor="middle"
          dominantBaseline="central"
          style={{
            fontSize: props.valueSize,
            fontFamily: "Roboto",
            fontWeight: "300",
          }}
        >
          ₪{totalWithCommas}
        </text>
        <text
          x={centerX}
          y={centerY - 35}
          textAnchor="middle"
          dominantBaseline="central"
          style={{
            fontSize: props.labelSize,
            fontFamily: "Assistant",
            fontWeight: "400",
          }}
          role="heading"
          aria-label="3"
        >
          {t("general.sum")}
        </text>
      </>
    );
  };
  return (
    <div
      className="chart"
      style={{ height: props.height, width: props.width }}
      dir="ltr"
    >
      <ResponsivePie
        data={generatePieData(props.redemptionRightData, i18n.language)}
        margin={{
          top: 5,
          left: 5,
          bottom: 5,
          right: 5,
        }}
        layers={[
          "arcs",
          "arcLabels",
          "arcLinkLabels",
          "legends",
          CenteredMetric,
        ]}
        theme={{
          fontSize: "18px",
          fontFamily: "Assistant",
          fontWeight: 500,
        }}
        isInteractive={false}
        innerRadius={0.91}
        sortByValue={true}
        padAngle={3}
        cornerRadius={9}
        activeOuterRadiusOffset={8}
        colors={{ datum: "data.color" }}
        borderWidth={1}
        borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
        enableArcLinkLabels={false}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextColor="#333333"
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: "color" }}
        enableArcLabels={false}
        arcLabelsSkipAngle={10}
        arcLabelsTextColor={{ from: "color", modifiers: [["darker", 2]] }}
        defs={[
          {
            id: "dots",
            type: "patternDots",
            background: "inherit",
            color: "rgba(255, 255, 255, 0.3)",
            size: 4,
            padding: 1,
            stagger: true,
          },
          {
            id: "lines",
            type: "patternLines",
            background: "inherit",
            color: "rgba(255, 255, 255, 0.3)",
            rotation: -45,
            lineWidth: 6,
            spacing: 10,
          },
        ]}
        legends={props.legendsData && [props.legendsData]}
      />
    </div>
  );
};

export default FinancePie;
